import { Api } from './axios-config';
import { IBusinessView } from './businessService';
import { IUserView } from './userService';

export interface IBusinessAdminView {
  id: number;
  userId: number;
  user: IUserView;
  businessId: number;
  business: IBusinessView;
}

const getById = async (id: number): Promise<IBusinessAdminView> => {
  try {
    const { data } = await Api.get<IBusinessAdminView>(
      `/businessAdmin/${id}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByUserId = async (userId: number): Promise<IBusinessAdminView[]> => {
  try {
    const { data } = await Api.get<IBusinessAdminView[]>(
      `/businessAdmin/user/${userId}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface ICreateBusinessAdmin {
  userId: number;
  businessId: number;
}

const create = async (body: ICreateBusinessAdmin): Promise<number> => {
  try {
    const { data } = await Api.post(
      '/businessAdmin',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface IUpdateBusinessAdmin {
  id: number;
  userId: number;
  businessId: number;
}

const update = async (body: IUpdateBusinessAdmin): Promise<IBusinessAdminView> => {
  try {
    const { data } = await Api.put(
      '/businessAdmin',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const remove = async (id: number): Promise<void> => {
  try {
    await Api.delete(
      `/businessAdmin/${id}`
    );

  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const inviteEmployee = async (businessId: number, email: string, isReceptionist = false): Promise<string> => {
  try {
    const { data } = await Api.get<string>(
      `/business/${businessId}/invite-employee?email=${email}&isReceptionist=${isReceptionist}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const businessAdminService = {
  getById,
  getByUserId,
  create,
  update,
  remove,
  inviteEmployee
};